import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=a619062c&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=a619062c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a619062c",
  null
  
)

export default component.exports